import { ApolloClient, InMemoryCache, ApolloLink } from '@apollo/client';
import typeDefs from 'shared/domains/apollo/config/typeDefs';
import httpLink from 'shared/domains/apollo/link';
import authHeaders from './authHeaders';
const cache = new InMemoryCache();
const client = new ApolloClient({
    cache,
    link: ApolloLink.from([authHeaders, httpLink]),
    dataMasking: true,
    typeDefs,
    clientAwareness: {
        name: 'external-sharing',
        version: process.env.APP_VERSION,
    },
    devtools: {
        enabled: process.env.APP_ENV !== 'production',
    },
});
export default client;
